import React from 'react'
import '../static/style/header.css';
export default function Header() {
  return (
    <div className='page_header'>
    <a href="https://www.psgtech.edu/" target="_blank" rel="noopener noreferrer">
    PSG COLLEGE OF TECHNOLOGY
    </a>
    </div>
  )
}
